// extracted by mini-css-extract-plugin
module.exports = {"language":"styles_language__p5ng2","languages":"styles_languages__wjQvL"};